<template>
  <main-layout>
    <!--  左メニュー 開始  -->
    <div slot="left-side">
      <menubar screenIdParam="M-13-01"></menubar>
    </div>

    <el-row slot="header">
      <head-title class="cancel-width">
        <label slot="title">{{ $t("title.system.outlookMeetingRoom.crreate") }}</label>
        <narrow-down @click="MeetingRoomMapping" v-show="this.$checkFuncCode('130300')" v-auth="{ auth: '130601' }" slot="cancel">
          {{ $t("button.system.outlookMeetingRoom.search.mapping") }}
        </narrow-down>
        <narrow-down class="outlookCreate" @click="selectLinkArea" v-auth="{ auth: '130103' }" slot="create" :disabled="disableLink">
          {{ $t("button.system.outlookMeetingRoom.search.create") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">
      <div v-show="!unrelatedRoom && !disableLink || $IsSBManager()">
        <div class="panel-search margin-bottom">
          <el-form
            :model="query"
            :rules="rules"
            class="search-form"
            ref="ruleForm">

            <!--検索-->
            <div class="fm-row">
              <el-input
                class="input-keyword-type m-right-5 fm-input"
                v-model="query.meetingRoomName"
                maxlength="20"
                :placeholder="$t('label.common.meetingRoomPlaceHolder')">
              </el-input>
              <img class="el-icon-search fm-row search-mirror" @click="oneDialogVisible = true, twoDialogVisible = false" src="@/assets/icon/icon_search_black.svg" alt="" />
            </div>

            <!-- オーナー -->
            <div class="fm-row">
              <el-form-item prop="ownerExId">
                <el-input
                  maxlength="20"
                  class="fm-input"
                  v-model="query.ownerExId"
                  :placeholder="$t('label.system.meetingRoom.search.query.ownerExId') +
                      $t('label.system.owner.search.prompt.partialMatchs')">
                </el-input>
              </el-form-item>
              <sp-smart-lable-button class="fm-lb-btn line-limit-length" v-show="query.ownerName">
                {{ query.ownerName }}
              </sp-smart-lable-button>
              <button-index @click="selectOwner" class="fm-st-btn limit-length">
                {{ $t("button.common.select") }}
              </button-index>

              <!-- ビル -->
              <el-form-item prop="buildingExId">
                <el-input
                  maxlength="20"
                  class="fm-input"
                  v-model="query.buildingExId"
                  :placeholder="$t('label.system.meetingRoom.search.query.buildingExId') +
                      $t('label.system.owner.search.prompt.partialMatchs')">
                </el-input>
              </el-form-item>
              <sp-smart-lable-button class="fm-lb-btn line-limit-length" v-show="query.buildingName">
                {{ query.buildingName }}
              </sp-smart-lable-button>
              <button-index @click="selectBuilding" class="fm-st-btn limit-length">
                {{ $t("button.common.select") }}
              </button-index>
            </div>

            <!-- フロア -->
            <div class="fm-row">
              <el-form-item>
                <el-input
                  :readonly="true"
                  clearable
                  maxlength="50"
                  class="fm-input"
                  v-model="query.floorName"
                  :placeholder="$t('label.system.meetingRoom.search.query.floorSelect')">
                </el-input>
              </el-form-item>
              <button-index @click="selectFloor" class="fm-st-btn limit-length">
                {{ $t("button.common.select") }}
              </button-index>

              <!-- エリア名 -->
              <el-form-item>
                <el-input
                  :readonly="true"
                  clearable
                  maxlength="50"
                  class="fm-input"
                  v-model="query.areaName"
                  :placeholder="$t('label.system.meetingRoom.search.query.areaSelect')">
                </el-input>
              </el-form-item>
              <button-index @click="selectArea" class="fm-st-btn limit-length">
                {{ $t("button.common.select") }}
              </button-index>
            </div>

            <div class="fm-row btn-area">
              <narrow-down @click="searchMeetingRoom">
                {{ $t("button.common.narrow") }}
              </narrow-down>
              <cancel-narrow-down class="link-primary margin-left-8" @click="clearSearchParams">
                {{ $t("button.common.data.cleanUp") }}
              </cancel-narrow-down>

            </div>
          </el-form>
        </div>
        <!--   検索エリア終了   -->
        <div>
          <el-row v-show="isShow">
            <label
              v-show="isShow"
              class="list-title">
              {{ $t("label.system.meetingRoom.search.query.outlookMeetingRoomList")}}
            </label>
            <div class="text-right">
              <label
                class="label-right lable-right-16">
                  {{ $t("label.common.count") }}
              </label>
              <el-select
                @change="changePageSize"
                v-model="query.pageSize"
                class="zdyselect">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-row>
        </div>

        <el-row class="margin-top-28" ref="searchResultTable" id="search-result">
          <div v-if="this.isShow">
            <meeting-room-search-result-beautify
              :result="searchResult.body"
              :isShow="this.isShow"
              @on-detail="detailMeetingRoom"
              @on-edit="editMeetingRoom"
              @on-delete="deleteMeetingRoom"/>
          </div>
        </el-row>
        <!--   検索結果が表示されます end   -->
        <!--  pagination start  -->
        <div style="margin-top: 70px">
          <pagination
            v-show="searchResult.totalCount > 0"
            :page-size="query.pageSize"
            :page-number="searchResult.pageNumber"
            :totalPage="searchResult.totalPage"
            :totalCount="searchResult.totalCount"
            @on-paging="handlePagingAction" />
        </div>
      <!--  pagination end  -->
      </div>

      <div v-show="(disableLink || unrelatedRoom) && !$IsSBManager()">
        <div>
          <div class="outlook-title">
            施設（Outlook）一覧
          </div>
          <div class="outlook-title-list">
            Outlookと連携した施設の一覧です。
          </div>
        </div>
        <div class="panel-search flex-center" v-if="disableLink">
          <div class="outlook-text">
            この機能を使うには、Outlook連携設定が必要です。
          </div>
          <narrow-down @click="outlookLinkSetting">
            Outlook連携設定
          </narrow-down>
        </div>
        <div class="panel-search flex-center" v-if="!disableLink && unrelatedRoom">
          <div class="outlook-text">
            WorkOffice+と連携させるリソースを登録してください。
          </div>
          <narrow-down @click="selectLinkArea">
            {{ $t("button.system.outlookMeetingRoom.search.create") }}
          </narrow-down>
        </div>
      </div>

      <!-- オーナー選択子画面 -->
      <owner-search-popup
        :ownerExIdParam="query.ownerExId"
        :ownerNameParam="query.ownerName"
        :funcCode="'130100'"
        :ownerId="query.ownerExId"
        :visible.sync="ownerSearchFlg"
        @on-selected="getOwnerInfo" />

      <!-- ビル選択子画面 -->
      <building-search-popup
        :ownerIdParam="query.ownerId"
        :buildingExIdParam="query.buildingExId"
        :buildingNameParam="query.buildingName"
        :visible.sync="buildingSearchFlg"
        :funcCode="'130100'"
        @on-selected="getBuildingInfo" />

      <!-- フロア選択子画面 -->
      <floor-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorNameParam="query.floorName"
        :visible.sync="floorSearchFlg"
        :funcCode="'130100'"
        @on-selected="getFloorInfo" />

      <!-- エリア選択子画面 -->
      <area-search-popup
        :ownerIdParam="query.ownerId"
        :buildingIdParam="query.buildingId"
        :floorIdParam="query.floorId"
        :areaNameParam="query.areaName"
        :visible.sync="areaSearchFlg"
        :funcCode="'130100'"
        @on-selected="getAreaInfo" />


      <file-downloader-loading-dialog :dialogVisible="showLoading" />

      <outlook-select-area-popup
        :visible.sync="outlookSelectAreaFlg"
        :orgId="orgId"
        @outlook-save="onSave"
      />


    </div>


    <!--  body end  -->

  </main-layout>
</template>

<script>
import MainLayout from "@/layout/NewDesignLayout"
import MeetingRoomSearchResultBeautify from "@/components/system/MeetingRoomSearchResultBeautify"
import Pagination from "@/components/common/pagination/Pagination"
import OwnerSearchPopup from "@/components/system/popup/OwnerSearchPopup"
import BuildingSearchPopup from "@/components/system/popup/BuildingSearchPopup"
import FloorSearchPopup from "@/components/system/popup/FloorSearchPopup"
import AreaSearchPopup from "@/components/system/popup/AreaSearchPopup"
import RuleMeetingRoomSearch from "@/rules/rule-meetingroom-search"
import SystemManageApi from "@/api/SystemManageApi"
import errorCodeMsg from "@/utils/error-code-msg"
import narrowDown from "@/components/common/generalButton/NarrowDown"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"
// import labelButton from "@/components/common/sp-smart-lable-button/index"
import headTitle from "@/components/common/head/head"
import Menubar from "@/components/leftmenu/DashBoard"
import SpSmartLableButton from "@/components/common/sp-smart-lable-button"
import buttonIndex from "@/components/common/sp-smart-button/index";
// import SpSmartButton from "@/components/common/sp-smart-button"
import FileDownloaderLoadingDialog from "@/components/common/loading/FileDownloaderLoadingDialog"
import OutlookSelectAreaPopup from '@/components/system/popup/outlookSelectAreaPopup'


const DEFAULT_PAGE_SIZE = 10
const DEFAULT_PAGE_NUMBER = 1

export default {
  name: "MeetingRoomSearch",
  components: {
    MainLayout: MainLayout,
    MeetingRoomSearchResultBeautify: MeetingRoomSearchResultBeautify,
    Pagination: Pagination,
    Menubar: Menubar,
    OwnerSearchPopup: OwnerSearchPopup,
    BuildingSearchPopup: BuildingSearchPopup,
    FloorSearchPopup: FloorSearchPopup,
    AreaSearchPopup: AreaSearchPopup,
    narrowDown: narrowDown,
    cancelNarrowDown: cancelNarrowDown,
    // labelButton: labelButton,
    headTitle: headTitle,
    SpSmartLableButton: SpSmartLableButton,
    buttonIndex,
    FileDownloaderLoadingDialog,
    OutlookSelectAreaPopup,
  },
  data() {
    return {
      orgId: '',
      outlookSelectAreaFlg: false,
      outlookResourceSyncInfo: {},
      unrelatedRoom: false,
      disableLink: false,
      showLoading: false,
      ownerSearchFlg: false,
      buildingSearchFlg: false,
      floorSearchFlg: false,
      areaSearchFlg: false,
      query: {
        ownerId: null,
        ownerExId: null,
        ownerName: null,
        buildingId: null,
        buildingExId: null,
        buildingName: null,
        floorId: null,
        floorName: null,
        areaId: null,
        areaName: null,
        meetingRoomName: null,
        pointId: null,
        pointType: null,
        pageSize: DEFAULT_PAGE_SIZE,
        pageNumber: DEFAULT_PAGE_NUMBER,
        totalCount: 0,
      },
      //結果宣言に戻る
      isShow: false,
      rules: RuleMeetingRoomSearch.meetingroomSearchRules(this),
      isSearching: false,
      tableLoadingAnim: null,
      searchResult: {
        totalCount: 0,
        totalPage: 0,
        pageSize: 0,
        pageNumber: 0,
        body: [
          {
            ownerName: null,
            ownerExId: null,
            ownerId: null,
            buildingName: null,
            buildingExId: null,
            buildingId: null,
            floorId: null,
            floorName: null,
            areaId: null,
            areaName: null,
            meetingRoomId: null,
            meetingRoomName: null,
            capacity: null,
          },
        ],
      },
      options: [
        {
          value: 10,
          label: "",
        },
        {
          value: 20,
          label: "",
        },
        {
          value: 50,
          label: "",
        },
      ],
    };
  },
  methods: {
    changePageSize() {
      this.query.pageNumber = 1
      this.doneSearchMeetingRoom();
    },

    //施設フロアマップボタン
    MeetingRoomMapping() {
      this.$saveQueryParam("meeting_room_map_info_id", this.query)
      this.$router.push({
        name: "system-outlookMeetingRoom-mapinfo",
      });
    },
    //Outlookリソースを追加
    selectLinkArea() {
      this.outlookSelectAreaFlg = true;
    },
    onSave() {
      this.doneSearchMeetingRoom();
    },
    outlookLinkSetting() {
      this.$saveQueryParam("outlook_meeting_room_search_id", this.query)
      if (this.$IsOwnerManager()) {
          this.$router.push({
            name: "system-outlook-edit",
            query: {
              orgId: this.orgId,
              pageType: "1",
              flg:"outlook"
            }
          });
      } else {
          this.$router.push({
            name: "system-outlook-edit",
            query: {
              orgId: this.orgId,
              flg:"outlook"
            }
          });
      }


    },
    //オーナー選択
    selectOwner() {
      this.ownerSearchFlg = true;
    },
    //ビル選択
    selectBuilding() {
      this.buildingSearchFlg = true;
    },
    //フロア選択
    selectFloor() {
      this.floorSearchFlg = true;
    },
    //エリア選択
    selectArea() {
      this.areaSearchFlg = true;
    },

    //照会バータン
    detailMeetingRoom(meetingRoomId) {
      this.$saveQueryParam("outlook_meeting_room_search_id", this.query)
      this.$router.push({
        name: "system-outlookMeetingRoom-detail",
        params: {
          meetingRoomId: meetingRoomId,
        },
      });
    },
    //編集バータン
    editMeetingRoom(meetingRoomId) {
      this.$router.push({
        name: "system-outlookMeetingRoom-edit",
        params: {
          meetingRoomId: meetingRoomId,
        },
      });
    },
    //削除バータン
    deleteMeetingRoom(meetingRoomId, index) {
      this.showLoading = true
      this.showTableLoadingAnim();
      SystemManageApi.OutlookMeetingRoomDelete(meetingRoomId)
        .catch((error) => {
          errorCodeMsg(error, this)
        })
        .then(() => {
          let meetingRooms = this.searchResult.body;
          meetingRooms.splice(index, 1);
          this.deleteSuccess();
          this.showLoading = false
        })
        .finally(() => {
          this.hideTableLoadingAnim();
          this.searchMeetingRoom();
        });
    },
    //検索
    searchMeetingRoom() {
      this.$saveQueryParam("outlook_meeting_room_search_id", this.query)
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.doneSearchMeetingRoom();
        }
      });
    },
    //クリア
    clearSearchParams() {
      this.$saveQueryParam("outlook_meeting_room_search_id", null),
        (this.query.ownerId = null),
        (this.query.ownerExId = null),
        (this.query.ownerName = null),
        (this.query.buildingId = null),
        (this.query.buildingExId = null),
        (this.query.buildingName = null),
        (this.query.floorId = null),
        (this.query.floorName = null),
        (this.query.areaId = null),
        (this.query.areaName = null),
        (this.query.meetingRoomName = null),
        (this.query.pageSize = DEFAULT_PAGE_SIZE),
        (this.query.pageNumber = DEFAULT_PAGE_NUMBER),
        (this.query.totalCount = 0),
        (this.searchResult.totalPage = 0),
        (this.searchResult.totalCount = 0),
        (this.searchResult.body = []),
        (this.isShow = false),
        this.$refs["ruleForm"].resetFields();
    },
    //处理pagination事件
    handlePagingAction(pagination) {
      this.query.pageSize = pagination.pageSize;
      this.query.pageNumber = pagination.pageNumber;
      this.searchMeetingRoom();
      this.$refs.searchResultTable.$el.scrollIntoView()
    },
    //オーナー選択-子组件
    getOwnerInfo: function (owner) {
      if (this.query.ownerId != owner.id) {
        this.query.buildingId = null;
        this.query.buildingExId = null;
        this.query.buildingName = null;
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = owner.id;
      this.query.ownerName = owner.name;
      this.query.ownerExId = owner.exId;
    },
    //获取 ビル選択 子画面的值
    getBuildingInfo(building) {
      if (this.query.buildingId != building.buildingId) {
        this.query.floorId = null;
        this.query.floorName = null;
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = building.ownerId;
      this.query.ownerExId = building.ownerExId;
      this.query.ownerName = building.ownerName;
      this.query.buildingId = building.buildingId;
      this.query.buildingExId = building.buildingExId;
      this.query.buildingName = building.buildingName;
    },
    //获取 フロア選択子画面的值
    getFloorInfo(floor) {
      if (this.query.floorId != floor.floorId) {
        this.query.areaId = null;
        this.query.areaName = null;
      }
      this.query.ownerId = floor.ownerId;
      this.query.ownerName = floor.ownerName;
      this.query.ownerExId = floor.ownerExId;
      this.query.buildingName = floor.buildingName;
      this.query.buildingExId = floor.buildingExId;
      this.query.buildingId = floor.buildingId;
      this.query.floorName = floor.floorName;
      this.query.floorId = floor.floorId;
    },
    //获取 エリア選択子画面的值
    getAreaInfo(area) {
      this.query.ownerId = area.ownerId;
      this.query.ownerExId = area.ownerExId;
      this.query.ownerName = area.ownerName;
      this.query.buildingId = area.buildingId;
      this.query.buildingExId = area.buildingExId;
      this.query.buildingName = area.buildingName;
      this.query.floorId = area.floorId;
      this.query.floorName = area.floorName;
      this.query.areaId = area.areaId;
      this.query.areaName = area.areaName;
    },

    outlookResourceSyncInfoDetail(){
        SystemManageApi.OutlookResourceSyncInfoDetail(this.orgId)
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            if (data.body !== null) {
              this.outlookResourceSyncInfo = data.body
            }

            const requiredFields = [
              this.outlookResourceSyncInfo.outlookDomain,
              this.outlookResourceSyncInfo.tenantID,
              this.outlookResourceSyncInfo.applicationID,
              this.outlookResourceSyncInfo.applicationSecret
            ];

            const hasEmpty = requiredFields.some(
              v => v === null || v === undefined || v === ''
            );

            if (hasEmpty) {
              this.disableLink = true;
            } else {
              this.disableLink = false;
            }

          })
          .finally(() => {
          });

    },
    //会議室检索
    doneSearchMeetingRoom() {
      if (!this.isSearching) {
        this.isSearching = true;
        this.showTableLoadingAnim();
        this.searchResult.body = [];

        SystemManageApi.OutlookMeetingRoomSearch({
          pageSize: this.query.pageSize,
          pageNumber: this.query.pageNumber,
          ownerId: this.query.ownerId,
          ownerExId: this.query.ownerExId,
          buildingId: this.query.buildingId,
          buildingExId: this.query.buildingExId,
          floorId: this.query.floorId,
          areaId: this.query.areaId,
          roomName: this.query.meetingRoomName,
        })
          .catch((error) => {
            errorCodeMsg(error, this)
          })
          .then(({ data }) => {
            this.searchResult.totalCount = data.body.totalCount;
            this.searchResult.totalPage = data.body.totalPage;
            this.searchResult.pageSize = data.body.pageSize;
            this.searchResult.pageNumber = data.body.pageNumber;

            for (let bodys of data.body.body) {
              this.searchResult.body.push({
                ownerName: bodys.ownerName,
                ownerExId: bodys.ownerExId,
                ownerId: bodys.ownerId,
                buildingName: bodys.buildingName,
                buildingExId: bodys.buildingExId,
                buildingId: bodys.buildingId,
                floorId: bodys.floorId,
                // floorName: bodys.floorName + " "+this.$t('label.system.meetingRoom.create.floorNames'),
                floorName: bodys.floorName,
                deleteFlag: bodys.deleteFlag,
                areaId: bodys.areaId,
                areaName: bodys.areaName,
                meetingRoomId: bodys.roomId,
                meetingRoomName: bodys.roomName,
                capacity: bodys.capacity == 21 ? '21名以上' : bodys.capacity + " " + this.$t('label.system.meetingRoom.create.capacitySuffix'),
              });
            }
            this.hasNoRelatedMeetingRoom()
          })
          .finally(() => {
            this.isSearching = false;
            this.hideTableLoadingAnim();
            this.isShow = true;
          });
      }
    },
    //判断是否没有关联会议室
    hasNoRelatedMeetingRoom() {
      const meetingRoomName = this.query.meetingRoomName
      const ownerId = this.query.ownerId
      const buildingId = this.query.buildingId
      const buildingExId = this.query.buildingExId
      const ownerExId = this.query.ownerExId
      const floorId = this.query.floorId
      const areaId = this.query.areaId

      const noQueryCondition =
        !meetingRoomName &&
        !ownerId &&
        !buildingId &&
        !floorId &&
        !areaId &&
        !buildingExId &&
        !ownerExId

      const noResult =
        !this.searchResult ||
        !Array.isArray(this.searchResult.body) ||
        this.searchResult.body.length === 0

      this.unrelatedRoom = noQueryCondition && noResult
    },

    //显示表格加载动画
    showTableLoadingAnim() {
      if (this.tableLoadingAnim == null) {
        this.tableLoadingAnim = this.$loading({
          target: "#search-result",
          background: "#ebebe6"
        });
      }
    },
    //隐藏表格加载动画
    hideTableLoadingAnim() {
      if (this.tableLoadingAnim != null) {
        this.tableLoadingAnim.close();
        this.tableLoadingAnim = null;
      }
    },
    //削除
    deleteSuccess: function () {
      this.$messageIotSuccess(this.$t("message.common.delete", {
        field: this.$t("message.common.validation.meetingRoomsMessage"),
      }));
    },

  },
  watch: {
    query: {
      handler() {
        this.query.pageNumber = 1
      },
      deep: true
    }
  },
  mounted() {
    this.options[0].label = "10" + this.$t("label.common.case");
    this.options[1].label = "20" + this.$t("label.common.case");
    this.options[2].label = "50" + this.$t("label.common.case");
    this.orgId = this.$getLoginInfo().orgId;
    // if (!this.$IsSBManager()) {
    if (this.$IsOwnerManager() || this.$IsTenantManager()) {
      this.outlookResourceSyncInfoDetail()
    } else {
      this.disableLink = false;
    }
    if (!this.disableLink) {
      let queryObj = this.$getQueryParam("outlook_meeting_room_search_id")
      if (queryObj != null) {
        this.query = queryObj
      }
      this.doneSearchMeetingRoom();
    }

  },
  created() {
    this.$authCheck("020101")
    let breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "",
        title: "label.router.outlookMeetingRoom",
      },
    ];
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb);
  },
};
</script>

<style lang="scss" scoped>
.outlookCreate{
  ::v-deep .my-button.is-disabled{
    color: #fff!important;
    background-color: #329ca6!important;
    opacity: 0.5!important;
  }
}
.outlook-title{
  font-family: Hiragino Kaku Gothic ProN;
  font-weight: 300;
  font-style: W3;
  font-size: 20px;
  line-height: 20px;
  margin-bottom: 8px;
}
.outlook-title-list{
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  line-height: 100%;
  margin-bottom: 24px;
}
.flex-center {
  height: 227px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.outlook-text{
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 100%;
  margin-bottom: 24px;
}
::v-deep .fm-row .download-btn{
  .my-button{
    color: #525250;
    font-size: 13px;
    background-color: #f7f7f2 !important;
    left: 55px;
    position: relative;
    height: 40px;
    width: 188px;
    text-align: center;
  }
}
::v-deep .cancel-width {
  .my-button {
    width: 188px;
    height: 32px;
  }
}

.margin-bottom {
  margin-bottom: 60px;
}

.margin-right-20 {
  margin-right: 20px;
}

.line-limit-length {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.button-margin {
  margin-top: 4px;
}

.margin-left-20 {
  margin-left: 20px;
}

.el-form-item {
  margin-bottom: 24px;
}

::v-deep .zdyselect {
  width: 120px;
  font-size: 15px;
  height: 40px;
  border-radius: 15px;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #E6E6E1;

  .el-input__inner {
    height: 40px;
    border-radius: 10px;
    background-color: #F2F2ED;
    border: 0;
    color: #525250;
  }

  .el-input__suffix {
    top: 0px;
  }

  .el-input__icon {
    line-height: 25px !important;
  }
}

::v-deep .zdyInput {
  .el-input__inner {
    height: 26px;
    border-radius: 0px !important;
    color: #525250;
    border: 2px solid;
    border-color: #bce0fd;
    font-size: 12px;
  }

  .el-input__inner::placeholder {
    color: #bce0fd;
  }

  /* 谷歌 */
  .el-input__inner::-webkit-input-placeholder {
    color: #bce0fd;
  }
}

.label-right {
  position: relative;
  right: 10px;
  font-size: 16px;
}

.select-button {
  width: 146px;
}

.limit-length {
  width: 100px !important;
}

.fm-row .search-mirror {
  font-size: 24px;
  width: 26px;
  left: -473px;
  right: 0px;
  margin: 10px 8px 10px 12px;
  position: relative;
}

::v-deep .fm-row .select-key-word {
  .el-input__inner {
    position: relative;
    font-size: 15px;
    display: inline-block;
    width: 438px;
    padding-left: 40px;
    margin: 0px;
    height: 44px !important;
  }
}

.input-keyword-type {
  width: 432px;

  ::v-deep .el-input__inner {
    width: 442px !important;
    padding-left: 47px;
  }
}

::v-deep .cancel {
  .my-button {
    font-family: "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", "Meiryo", "ＭＳ ゴシック", sans-serif;
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    color: #525250;
    text-align: center;
    box-sizing: border-box;
    outline: none;
    margin: 0;
    transition: 0.1s;
    padding: 10px 20px;
    font-size: 13px;
    border-radius: 8px;
    width: 188px;
    height: 32px;
    z-index: 600;
    background-color: #f2f2ed;
    border: 0;
  }
}
</style>
